
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Attribute": [
      "AlternativeTextAttribute",
      "CaptionAttribute",
      "ExcludeReadingOrderAttribute",
      "ExpressionAttribute",
      "FigureAttribute",
      "FootnoteAttribute",
      "HeaderLevelAttribute",
      "ImageAttribute",
      "ListAttribute",
      "ListItemAttribute",
      "ListItemLabelAttribute",
      "PaginationArtifactAttribute",
      "TableAttribute",
      "TableCellAttribute",
      "TableHeaderCellAttribute",
      "TableOfContentsAttribute",
      "TableOfContentsHeadingAttribute",
      "TableOfContentsItemAttribute",
      "TableOfContentsPageNumberAttribute",
      "TextAttribute"
    ],
    "Connection": [
      "ArtifactConnection",
      "MembershipConnection",
      "PageConnection",
      "RegionConnection",
      "TableGroupConnection",
      "UserConnection"
    ],
    "Edge": [
      "ArtifactEdge",
      "MembershipEdge",
      "PageEdge",
      "RegionEdge",
      "TableGroupEdge"
    ],
    "Node": [
      "AlternativeTextAttribute",
      "Artifact",
      "CaptionAttribute",
      "Document",
      "ExcludeReadingOrderAttribute",
      "ExpressionAttribute",
      "FigureAttribute",
      "FootnoteAttribute",
      "HeaderLevelAttribute",
      "ImageAttribute",
      "Issue",
      "ListAttribute",
      "ListItemAttribute",
      "ListItemLabelAttribute",
      "MetadataAuthor",
      "MetadataSubject",
      "MetadataTitle",
      "Page",
      "PaginationArtifactAttribute",
      "Region",
      "TableAttribute",
      "TableCellAttribute",
      "TableGroup",
      "TableHeaderCellAttribute",
      "TableOfContentsAttribute",
      "TableOfContentsHeadingAttribute",
      "TableOfContentsItemAttribute",
      "TableOfContentsPageNumberAttribute",
      "Task",
      "TaskMessage",
      "TextAttribute",
      "User"
    ],
    "Payload": [
      "AddAuthorPayload",
      "AddDocumentTagPayload",
      "AddSubjectPayload",
      "AddTableGroupPayload",
      "AddTitlePayload",
      "ChangeSubjectPayload",
      "ChangeTableGroupDescriptionPayload",
      "ChangeTitleLanguagePayload",
      "CreateAlternativeTextAttributePayload",
      "CreateArtifactPayload",
      "CreateCaptionAttributePayload",
      "CreateExcludeReadingOrderAttributePayload",
      "CreateExpressionAttributePayload",
      "CreateFigureAttributePayload",
      "CreateFootnoteAttributePayload",
      "CreateHeaderLevelAttributePayload",
      "CreateImageAttributePayload",
      "CreateListAttributePayload",
      "CreateListItemAttributePayload",
      "CreateListItemLabelAttributePayload",
      "CreatePaginationArtifactAttributePayload",
      "CreateRegionPayload",
      "CreateTableAttributePayload",
      "CreateTableCellAttributePayload",
      "CreateTableHeaderCellAttributePayload",
      "CreateTableOfContentsAttributePayload",
      "CreateTableOfContentsHeadingAttributePayload",
      "CreateTableOfContentsItemAttributePayload",
      "CreateTableOfContentsPageNumberAttributePayload",
      "CreateTextAttributePayload",
      "DeleteArtifactPayload",
      "DeleteAttributePayload",
      "DeleteAttributesPayload",
      "DeleteDocumentPayload",
      "DeleteRegionPayload",
      "RemoveAuthorPayload",
      "RemoveDocumentTagPayload",
      "RemoveSubjectPayload",
      "RemoveTableGroupPayload",
      "RemoveTitlePayload",
      "RenameAuthorPayload",
      "RenameDocumentPayload",
      "RenameTableGroupPayload",
      "RenameTitlePayload",
      "SetDatePayload",
      "SetLanguagePayload",
      "SetTableAttributeTableGroupPayload",
      "StartPageSegmentationPayload",
      "UpdateAlternativeTextAttributePayload",
      "UpdateCaptionAttributePayload",
      "UpdateDocumentPermissionPayload",
      "UpdateExpressionAttributePayload",
      "UpdateHeaderLevelAttributePayload",
      "UpdateListAttributePayload",
      "UpdateListItemAttributePayload",
      "UpdatePaginationArtifactAttributePayload",
      "UpdateRegionNextRegionPayload",
      "UpdateRegionReadingOrderIndexPayload",
      "UpdateRegionShapePayload",
      "UpdateTableAttributePayload",
      "UpdateTableCellAttributePayload",
      "UpdateTableHeaderCellAttributePayload",
      "UpdateTableOfContentsItemAttributePayload",
      "UpdateTextAttributePayload"
    ],
    "UserError": [
      "NoFixError"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Attribute": [
      "AlternativeTextAttribute",
      "CaptionAttribute",
      "ExcludeReadingOrderAttribute",
      "ExpressionAttribute",
      "FigureAttribute",
      "FootnoteAttribute",
      "HeaderLevelAttribute",
      "ImageAttribute",
      "ListAttribute",
      "ListItemAttribute",
      "ListItemLabelAttribute",
      "PaginationArtifactAttribute",
      "TableAttribute",
      "TableCellAttribute",
      "TableHeaderCellAttribute",
      "TableOfContentsAttribute",
      "TableOfContentsHeadingAttribute",
      "TableOfContentsItemAttribute",
      "TableOfContentsPageNumberAttribute",
      "TextAttribute"
    ],
    "Connection": [
      "ArtifactConnection",
      "MembershipConnection",
      "PageConnection",
      "RegionConnection",
      "TableGroupConnection",
      "UserConnection"
    ],
    "Edge": [
      "ArtifactEdge",
      "MembershipEdge",
      "PageEdge",
      "RegionEdge",
      "TableGroupEdge"
    ],
    "Node": [
      "AlternativeTextAttribute",
      "Artifact",
      "CaptionAttribute",
      "Document",
      "ExcludeReadingOrderAttribute",
      "ExpressionAttribute",
      "FigureAttribute",
      "FootnoteAttribute",
      "HeaderLevelAttribute",
      "ImageAttribute",
      "Issue",
      "ListAttribute",
      "ListItemAttribute",
      "ListItemLabelAttribute",
      "MetadataAuthor",
      "MetadataSubject",
      "MetadataTitle",
      "Page",
      "PaginationArtifactAttribute",
      "Region",
      "TableAttribute",
      "TableCellAttribute",
      "TableGroup",
      "TableHeaderCellAttribute",
      "TableOfContentsAttribute",
      "TableOfContentsHeadingAttribute",
      "TableOfContentsItemAttribute",
      "TableOfContentsPageNumberAttribute",
      "Task",
      "TaskMessage",
      "TextAttribute",
      "User"
    ],
    "Payload": [
      "AddAuthorPayload",
      "AddDocumentTagPayload",
      "AddSubjectPayload",
      "AddTableGroupPayload",
      "AddTitlePayload",
      "ChangeSubjectPayload",
      "ChangeTableGroupDescriptionPayload",
      "ChangeTitleLanguagePayload",
      "CreateAlternativeTextAttributePayload",
      "CreateArtifactPayload",
      "CreateCaptionAttributePayload",
      "CreateExcludeReadingOrderAttributePayload",
      "CreateExpressionAttributePayload",
      "CreateFigureAttributePayload",
      "CreateFootnoteAttributePayload",
      "CreateHeaderLevelAttributePayload",
      "CreateImageAttributePayload",
      "CreateListAttributePayload",
      "CreateListItemAttributePayload",
      "CreateListItemLabelAttributePayload",
      "CreatePaginationArtifactAttributePayload",
      "CreateRegionPayload",
      "CreateTableAttributePayload",
      "CreateTableCellAttributePayload",
      "CreateTableHeaderCellAttributePayload",
      "CreateTableOfContentsAttributePayload",
      "CreateTableOfContentsHeadingAttributePayload",
      "CreateTableOfContentsItemAttributePayload",
      "CreateTableOfContentsPageNumberAttributePayload",
      "CreateTextAttributePayload",
      "DeleteArtifactPayload",
      "DeleteAttributePayload",
      "DeleteAttributesPayload",
      "DeleteDocumentPayload",
      "DeleteRegionPayload",
      "RemoveAuthorPayload",
      "RemoveDocumentTagPayload",
      "RemoveSubjectPayload",
      "RemoveTableGroupPayload",
      "RemoveTitlePayload",
      "RenameAuthorPayload",
      "RenameDocumentPayload",
      "RenameTableGroupPayload",
      "RenameTitlePayload",
      "SetDatePayload",
      "SetLanguagePayload",
      "SetTableAttributeTableGroupPayload",
      "StartPageSegmentationPayload",
      "UpdateAlternativeTextAttributePayload",
      "UpdateCaptionAttributePayload",
      "UpdateDocumentPermissionPayload",
      "UpdateExpressionAttributePayload",
      "UpdateHeaderLevelAttributePayload",
      "UpdateListAttributePayload",
      "UpdateListItemAttributePayload",
      "UpdatePaginationArtifactAttributePayload",
      "UpdateRegionNextRegionPayload",
      "UpdateRegionReadingOrderIndexPayload",
      "UpdateRegionShapePayload",
      "UpdateTableAttributePayload",
      "UpdateTableCellAttributePayload",
      "UpdateTableHeaderCellAttributePayload",
      "UpdateTableOfContentsItemAttributePayload",
      "UpdateTextAttributePayload"
    ],
    "UserError": [
      "NoFixError"
    ]
  }
};
      export default result;
    